import { AxiosError } from 'axios';
import useSWR, { SWRResponse } from 'swr';
import { useRecoilValue } from 'recoil';
import { authState } from '@/stores/authStore';
import { authFetcher } from '@/core/http';
import { useUser } from '@/services/userService';
import {
  GetBillingSubscriptionsResponse,
  parseBillingSubscriptionResponse,
} from './billingTypes';

export const BILLING_SUBSCRIPTION_SWR_KEY = '/billing/subscription';

const billingSubscriptionFetcher = ([url, token]: [
  string,
  string
]): Promise<GetBillingSubscriptionsResponse> =>
  authFetcher([url, token]).then(parseBillingSubscriptionResponse);

export function useBillingSubscription(): SWRResponse<
  GetBillingSubscriptionsResponse,
  AxiosError
> {
  const { token, isGuestToken } = useRecoilValue(authState);
  const { data: user } = useUser();

  const isEligible = !isGuestToken && !!token && !!user;

  return useSWR<GetBillingSubscriptionsResponse, AxiosError>(
    isEligible ? [BILLING_SUBSCRIPTION_SWR_KEY, token] : null,
    billingSubscriptionFetcher
  );
}
